import Home from '../Home.vue'
import flowList from './abstract/list.vue'
import flowAdd from './abstract/add.vue'
import flowEdit from './abstract/edit.vue'
import flowDesign from './abstract/design.vue'
import flowMessage from './abstract/message.vue'
import flow from './instance/flow.vue'
import addFlow from './instance/addFlow.vue'
import myFlow from './instance/myFlow.vue'
import mystart from './instance/mystart.vue'
import flowForm from './instance/form.vue'
import flowCaseList from './instance/list.vue'
import flowDetail from './instance/detail.vue'
import follow from './instance/follow.vue'
import data from './instance/data.vue'
import flowtypeList from './classify/list.vue'
import flowtypeAdd from './classify/add.vue'      // 弃用
import flowtypeEdit from './classify/edit.vue'
import followDetail from './instance/details/followDetail.vue'
import myStartDetail from './instance/details/myStartDetail.vue'
import myFlowDetail from './instance/details/myFlowDetail.vue'
import dataDetail from './instance/details/dataDetail.vue'

const routes = [
  {
    path: '/home',
    component: Home,
    children: [
      { path: '/flowtype/list', component: flowtypeList, name: 'flowtypeList', meta: { hideLeft: false, menuGet: 'bpm/types', module: 'Administrative', menu: 'flow' }},
      { path: '/flowtype/add', component: flowtypeAdd, name: 'flowtypeAdd', meta: { hideLeft: false, menuGet: 'bpm/types', module: 'Administrative', menu: 'flow' }},
      { path: '/flowtype/edit', component: flowtypeEdit, name: 'flowtypeEdit', meta: { hideLeft: false, menuGet: 'bpm/types', module: 'Administrative', menu: 'flow' }}
    ]
  },
  {
    path: '/home',
    component: Home,
    children: [
      { path: '/flow/list', component: flowList, name: 'flowList', meta: { hideLeft: false, menuGet: 'bpm/types', module: 'Administrative', menu: 'flow' }},
      { path: '/flow/add', component: flowAdd, name: 'flowAdd', meta: { hideLeft: false, menuGet: 'bpm/types', module: 'Administrative', menu: 'flow' }},
      { path: '/flow/edit/:id', component: flowEdit, name: 'flowEdit', meta: { hideLeft: false, menuGet: 'bpm/types', module: 'Administrative', menu: 'flow' }},
      { path: '/flow/design/:id', component: flowDesign, name: 'flowDesign', meta: { hideLeft: true, menuGet: 'bpm/types', module: 'Administrative', menu: 'flow' }},
      { path: '/flow/message', component: flowMessage, name: 'flowMessage', meta: { hideLeft: false, menuGet: 'bpm/types', module: 'Administrative', menu: 'flow' }}
      // { path: '/flow/myFlow', component: myFlow, name: 'myFlow', meta: { hideLeft: false, menuGet: 'bpm/types', module: 'Flow', menu: 'myFlow', isFlow: true }},
      // { path: '/flow/follow', component: follow, name: 'follow', meta: { hideLeft: false, menuGet: 'bpm/types', module: 'Flow', menu: 'follow', isFlow: true }},
      // { path: '/flow/mystart', component: mystart, name: 'mystart', meta: { hideLeft: false, menuGet: 'bpm/types', module: 'Flow', menu: 'mystart', isFlow: true }},
      // { path: '/flow/data', component: data, name: 'data', meta: { hideLeft: false, menuGet: 'bpm/types', module: 'Flow', menu: 'data', isFlow: true }}
    ]
  },
  {
    path: '/home',
    component: Home,
    children: [
      { path: '/flow/caseList/:id', component: flowCaseList, name: 'flowCaseList', meta: { hideLeft: false, menuGet: 'bpm/types', module: 'Flow', menu: 'flowCase' }},
      { path: '/flow/form/:id', component: flowForm, name: 'flowForm', meta: { hideLeft: true, menuGet: 'bpm/types', module: 'Flow', menu: 'addFlow' }},
      { path: '/flow/detail/:id', component: flowDetail, name: 'flowDetail', meta: { hideLeft: false, menuGet: 'bpm/types', module: 'Flow', menu: 'addFlow' }}
    ]
  },
  {
    path: '/home',
    component: Home,
    children: [
      { path: '/flowtype/flow', component: flow, name: 'flow', meta: { hideLeft: true, menuGet: 'bpm/types', module: 'Flow', menu: 'flow', isFlow: true }, children: [
        { path: '/flowtype/addFlow', component: addFlow, name: 'addFlow', meta: { hideLeft: true, menuGet: 'bpm/types', module: 'Flow', menu: 'addFlow', isFlow: true }},
        { path: '/flow/myFlow', component: myFlow, name: 'myFlow', meta: { hideLeft: true, menuGet: 'bpm/types', module: 'Flow', menu: 'myFlow', isFlow: true }},
        { path: '/flow/follow', component: follow, name: 'follow', meta: { hideLeft: true, menuGet: 'bpm/types', module: 'Flow', menu: 'follow', isFlow: true }},
        { path: '/flow/mystart', component: mystart, name: 'mystart', meta: { hideLeft: true, menuGet: 'bpm/types', module: 'Flow', menu: 'mystart', isFlow: true }},
        { path: '/flow/data', component: data, name: 'data', meta: { hideLeft: true, menuGet: 'bpm/types', module: 'Flow', menu: 'data', isFlow: true }}
      ] },
      { path: '/flow/followDeatil/:id', component: followDetail, name: 'followDetail', meta: { hideLeft: true, menuGet: 'bpm/types', module: 'Flow', menu: 'follow' }},
      { path: '/flow/myStartDetail/:id', component: myStartDetail, name: 'myStartDetail', meta: { hideLeft: true, menuGet: 'bpm/types', module: 'Flow', menu: 'mystart' }},
      { path: '/flow/myFlowDetail/:id', component: myFlowDetail, name: 'myFlowDetail', meta: { hideLeft: true, menuGet: 'bpm/types', module: 'Flow', menu: 'myFlow' }},
      { path: '/flow/dataDetail/:id', component: dataDetail, name: 'dataDetail', meta: { hideLeft: true, menuGet: 'bpm/types', module: 'Flow', menu: 'data' }}
    ]
  }
]
export default routes



// WEBPACK FOOTER //
// ./src/components/Flow/routes.js